import global from "../../../config/global";

const baseURL = global.apisUrl + "/auth";

export const signupURL = baseURL + "/signup";
export const loginURL = baseURL + "/login";
export const meURL = baseURL + "/me";
